import { render, staticRenderFns } from "./ViewMethodResearchPlan.vue?vue&type=template&id=21c0aba2"
import script from "./ViewMethodResearchPlan.vue?vue&type=script&lang=js"
export * from "./ViewMethodResearchPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports